/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiscountType } from './discountType';


export interface CreateDiscountDto { 
    code: string;
    name: string;
    discountPriceType?: DiscountType;
    discountAmount?: number;
    discountHours?: number;
    activeFrom?: string;
    activeTo?: string;
    isActive?: boolean;
    waiveServiceFee?: boolean;
    waiveTax?: boolean;
}
export namespace CreateDiscountDto {
}


